import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/shared/PageTitle';
import BaseUrl from "../../config/constant";

export default function Index() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validation, setValidation] = useState({
    status: {},
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const locale = useSelector((state) => state.locale.locale);

  useEffect(() => {
    if (localStorage.getItem('jwt-token')) {
      navigate('/profile');
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('uusrEmail', email);
    formData.append('uusrPassword', password);

    await axios
      .post(`${BaseUrl}/login`, {
        data: {
          uusrEmail: email,
          uusrPassword: password,
        },
      })
      .then((response) => {
        localStorage.setItem('jwt-token', JSON.stringify(response.data.data));

        navigate('/profile');
        setLoading(false);
      })
      .catch((error) => {
        setValidation(error.response.data);
        setLoading(false);
      });
  };

  return (
    <div className="md:px-0 px-4">
      <div className="relative text-center">
        <PageTitle title={locale === 'en' ? 'Sign In' : 'Masuk'} />
      </div>
      <div className="relative top-80 bg-black 2xl:px-0 md:px-14 px-0 pb-96">
        <div className="bg-black min-h-screen h-full container mx-auto w-full font-ttFirsNeue">
          <div className="mx-auto w-full max-w-lg p-6 rounded-lg shadow-xs border bg-white bg-opacity-15 backdrop-blur-md  border-white/10">
            {Object.hasOwn(validation.status, 'error') && (
              <div className="text-center mb-4 px-3 py-2.5 w-full bg-red-300 backdrop-blur-md text-red-900 text-sm rounded-lg">
                Gagal masuk. Silakan periksa kembali email dan password Anda.
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="text-white block mb-2.5 text-sm font-medium text-heading"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-lg focus:ring-brand focus:border-brand block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  placeholder="e.g. runner@semarang10k.com"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="text-white block mb-2.5 text-sm font-medium text-heading"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-lg focus:ring-brand focus:border-brand block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  placeholder="•••••••••"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="flex items-start my-4">
                <a
                  href="https://ultimate10kseries.com/forgot-password"
                  target="_blank"
                  rel="noreferrer"
                  className="ms-auto text-sm font-bold text-fg-brand hover:underline text-[#F79838]"
                >
                  Forgot password?
                </a>
              </div>
              <button
                disabled={loading}
                type="submit"
                className={`${loading && 'hover:cursor-not-allowed'} text-white border bg-[#F79838] border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs font-bold leading-5 rounded-lg text-sm px-4 py-2.5 focus:outline-none w-full mb-3`}
              >
                {loading ? (
                  <div className='flex items-center justify-center'>
                    <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-current" />
                  </div>
                ) : 'Sign In'} 
              </button>
              <hr />
              <div className="text-white mt-4 text-sm font-extralight text-body">
                Don't have a runner account?{' '}
                <a
                  href="https://ultimate10kseries.com/daftar"
                  target="_blank"
                  rel="noreferrer"
                  className="text-fg-brand font-bold hover:underline text-[#F79838]"
                >
                  Register here
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
